module.exports = __webpack_public_path__ + "img/undraw2.d3cb7cf5.jpg";